exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".global-tool-bar[data-v-0ec549f0] {\n  margin-bottom: 16px;\n}\n.global-tool-bar .title[data-v-0ec549f0] {\n  font-size: 18px;\n  font-weight: bold;\n}\n", ""]);

// exports
